import { AppState } from '@chegg-wt/core/state'
import React from 'react'
import { connect, useSelector } from 'react-redux'
import BackLink from '@chegg-wt/core/components/BackLink'
import { Advert } from '@chegg-wt/core/components/Advert'
import ErrorContainer from '@chegg-wt/core/components/ErrorContainer'
import ConfirmCitation from '@chegg-wt/core/components/ConfirmCitation'
import ConfirmCitationNav from '@chegg-wt/core/components/ConfirmCitationNav'
import ConfirmCMSContent from '@chegg-wt/core/components/ConfirmCMSContent'
import { MainWrapper, PageHeaderWrapper } from '@chegg-wt/core/components/Layouts/styled'

import { currentCitationSourceSelector } from '@chegg-wt/core/state/citation/selectors'
import { createCitationQuerySelector } from '@chegg-wt/core/state/createCitation/selectors'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { updateMessagingFlagSelector } from '@chegg-wt/core/state/app/selectors'
import { Config } from '@chegg-wt/core/config'
import { CM } from '@chegg-wt/core/constants/site'
import { LvpMarginWrapper } from '../LargeVideoPlayerLayout'
import { SubHeadingBCRest } from '../../BrandConsolidation'
import { ConfirmPageProps, ConfirmPageStateProps } from './types'
import * as Styled from './styled'

export const ConfirmPageTop: React.FC = () => {
  const updateMessagingFeatureEnabled = useSelector(updateMessagingFlagSelector)
  const { appName } = Config
  return (
    <>
      <BackLink />
      <PageHeaderWrapper>
        <Styled.Header>Review information</Styled.Header>
        {(appName !== CM || updateMessagingFeatureEnabled) && <SubHeadingBCRest />}
      </PageHeaderWrapper>
    </>
  )
}
const ConfirmPage: React.FunctionComponent<ConfirmPageProps> = ({
  copy,
  currentStyle,
  currentSourceType,
  currentSearchQuery,
}) => (
  <div className="formWrapper">
    <div>
      <Styled.Container className="eval-page container-fluid">
        <ErrorContainer />
        <LvpMarginWrapper>
          <div className="row center-children">
            <div id="eval-container0">
              <MainWrapper>
                <ConfirmCitation />
              </MainWrapper>
            </div>
            <div id="eval-container1">
              <ConfirmCitationNav
                style={currentStyle}
                sourceType={currentSourceType}
                searchQuery={currentSearchQuery}
              />
            </div>
          </div>
          <Advert placement="C2" />
        </LvpMarginWrapper>
        {!!copy && <ConfirmCMSContent copy={copy} />}
        <Advert placement="C1" />
      </Styled.Container>
    </div>
  </div>
)

const mapStateToProps = (state: AppState) => ({
  currentStyle: currentStyleSelector(state),
  currentSourceType: currentCitationSourceSelector(state),
  currentSearchQuery: createCitationQuerySelector(state),
})

export default connect<ConfirmPageStateProps>(mapStateToProps)(ConfirmPage)
